import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

const Store = new Vuex.Store({
  state: {
    localization: 'tr',
    menu: [],
    allowedRoutes: [],
    user: {
      id: null,
      name: null,
      domainId: null,
      domainCode: null,
      domainName: null,
      unitCode: null
    },
    dialogLoading: false,
    dialogOkLoading: false,
    dialogCancelLoading: false,
    screenshotLoading: false,
    processId: null,
    processCode: "",
    itemsPerPageMap: {},
    selected: []
  },

  //getting state variables: use for computing values to view
  getters: {
    menu: state => state.menu,
    allowedRoutes: state => state.allowedRoutes,
    user: state => state.user,
    processId: state => state.processId,
    processCode: state => state.processCode,
    dialogLoading: state => state.dialogLoading,
    dialogOkLoading: state => state.dialogOkLoading,
    dialogCancelLoading: state => state.dialogCancelLoading,
    screenshotLoading: state => state.screenshotLoading,
    itemsPerPageMap: state => state.itemsPerPageMap,
    localization: state => state.localization,
    selected: state => state.selected
  },

  //for setting state variables manually:
  mutations: {
    LOCALIZATION: (state,value) => {
      state.localization = value;
    },
    SCREEN_SHOT_LOADING: (state, status) => {
      state.screenshotLoading = status;
    },
    SET_DIALOG_LOADING: (state, status) => {
      state.dialogLoading = status;
    },
    SET_DIALOG_OK_LOADING: (state, status) => {
      state.dialogOkLoading = status;
    },
    SET_DIALOG_CANCEL_LOADING: (state, status) => {
      state.dialogCancelLoading = status;
    },
    CLEAR_NAVIGATION_MENU: state => {
      state.menu = [];
    },
    SET_NAVIGATION_MENU: (state, menu) => {
      state.menu = menu;
    },
    CLEAR_ALLOWED_ROUTES: state => {
      state.allowedRoutes = [];
    },
    CLEAR_USER: state => {
      state.user.id = null;
      state.user.name = null;
      state.user.domainId = null;
      state.user.domainCode = null;
      state.user.domainName = null;
      state.user.unitCode = null;
    },
    SET_ALLOWED_ROUTES: (state, routes) => {
      state.allowedRoutes = [];
      if (routes != null && routes.length > 0) {
        for (const route of routes) {
          if (!state.allowedRoutes.some(item => item.name === route.name)) {
            state.allowedRoutes.push(route);
          }
        }
      }
    },
    SET_USER: (state, user) => {
      state.user.id = user.id;
      state.user.name = user.name;
      state.user.domainId = user.domainId;
      state.user.domainCode = user.domainCode;
      state.user.domainName = user.domainName;
      state.user.unitCode = user.unitCode;
    },
    CLEAR_PROCESS_ID: state => {
      state.processId = null;
    },
    SET_PROCESS_ID: (state, processId) => {
      state.processId = processId;
    },
    SET_PROCESS_CODE: (state, processCode) => {
      state.processCode = processCode;
    },
    SET_ITEMS_PER_PAGE_MAP: (state, itemsPerPageMap) => {
      state.itemsPerPageMap = itemsPerPageMap;
    },
    SET_SELECTED: (state, selected) => {
      state.selected = selected;
    }
  },

  actions: {
    setLocalization({commit},value) {
      commit("LOCALIZATION",value);
    },
    screenShotLoading({ commit }, status) {
      commit("SCREEN_SHOT_LOADING", status);
    },
    setDialogLoading({ commit }, status) {
      commit("SET_DIALOG_LOADING", status);
    },
    setDialogOkLoading({ commit }, status) {
      commit("SET_DIALOG_OK_LOADING", status);
    },
    setDialogCancelLoading({ commit }, status) {
      commit("SET_DIALOG_CANCEL_LOADING", status);
    },
    clearNavigationMenu({ commit }) {
      commit("CLEAR_NAVIGATION_MENU");
    },
    setNavigationMenu({ commit }, menu) {
      commit("SET_NAVIGATION_MENU", menu);
    },
    clearAllowedRoutes({ commit }) {
      commit("CLEAR_ALLOWED_ROUTES");
    },
    setAllowedRoutes({ commit }, routes) {
      commit("SET_ALLOWED_ROUTES", routes);
    },
    clearUser({ commit }) {
      commit("CLEAR_USER");
    },
    setUser({ commit }, user) {
      commit("SET_USER", user);
    },
    clearProcessId({ commit }) {
      commit("CLEAR_PROCESS_ID");
    },
    setProcessId({ commit }, processId) {
      commit("SET_PROCESS_ID", processId);
    },
    setProcessCode({ commit }, processCode) {
      commit("SET_PROCESS_CODE", processCode);
    },
    setItemsPerPageMap({ commit }, itemsPerPageMap) {
      commit("SET_ITEMS_PER_PAGE_MAP", itemsPerPageMap);
    }
  },
  plugins: [vuexLocal.plugin]
});

export default Store;



// WEBPACK FOOTER //
// ./src/store/index.js